import { render, staticRenderFns } from "./Direktorat.vue?vue&type=template&id=aac4c21e"
import script from "./Direktorat.vue?vue&type=script&lang=js"
export * from "./Direktorat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports